import { jsx as C } from "react/jsx-runtime";
const H = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 5.0981L13.5 18H14.5L14.5 8.25H15C15.9665 8.25 16.75 9.0335 16.75 10V17C16.75 17.0849 16.744 17.1683 16.7323 17.25H18.5C18.9142 17.25 19.25 17.5858 19.25 18C19.25 18.4142 18.9142 18.75 18.5 18.75H15H14H12H9H5C4.58579 18.75 4.25 18.4142 4.25 18C4.25 17.5858 4.58579 17.25 5 17.25H7.26772C7.25604 17.1683 7.25 17.0849 7.25 17V6C7.25 5.0335 8.0335 4.25 9 4.25H12C12.6366 4.25 13.1938 4.5899 13.5 5.0981Z",
    fill: "currentColor"
  }
);
export {
  H as default
};
